/** Shared copy for the non-blocking "recording not required" info bar (student + lecturer). */
export const RECORDING_NOT_REQUIRED_INFO = {
  copyKey: 'oralExam.recording.notRequiredInfo',
  defaultValue: 'This exam is not being recorded. Your session will continue normally.',
} as const;

/**
 * Stable placeholder body when recording was not required for the exam session.
 * Must match `RECORDING_DISABLED_TRANSCRIPT_MARKER` in
 * `api/app/core/services/appointments/recording_evidence.py`.
 */
export const RECORDING_DISABLED_TRANSCRIPT_MARKER = '[Recording disabled; no transcript captured]';
